/* eslint-disable max-len */
// Copyright (c) 2016 Deere & Company

import NewTransferStatusChangeModal, { getDefaultState } from '../state/new-transfer-status-change-modal';
import actions from '../../../../sharedmodules/actions-list';

const updateNewTransferStatusChangeModal = (state, action) => NewTransferStatusChangeModal.update(state, {
    [action.name]: {
        $set: action.value,
    },
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_NEW_TRANSFER_STATUS_CHANGE_MODAL]: updateNewTransferStatusChangeModal,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
